(() => {
  if (window.__vzyDrawerPatch) return;
  window.__vzyDrawerPatch = true;

  window.vzyDrawerAddOne = (button, line) => {
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    const drawer = button.closest('cart-drawer');
    const plus = drawer?.querySelector(`#CartDrawer-Item-${line} quantity-input button[name="plus"]`);
    if (!(plus instanceof HTMLButtonElement) || plus.disabled) return;

    const label = button.textContent;
    let releaseTimer;
    const release = () => {
      window.clearTimeout(releaseTimer);
      document.removeEventListener('line-item:change', release);
      document.removeEventListener('cart:error', release);
      if (!button.isConnected) return;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (button.textContent !== label) button.textContent = label;
    };

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Se adaugă…';
    document.addEventListener('line-item:change', release);
    document.addEventListener('cart:error', release);
    releaseTimer = window.setTimeout(release, 8000);
    plus.click();
  };

  customElements.whenDefined('cart-drawer').then(() => {
    const Drawer = customElements.get('cart-drawer');
    if (!Drawer || Drawer.prototype.__vzyPatched) return;

    const originalOpen = Drawer.prototype.open;
    const originalRenderContents = Drawer.prototype.renderContents;

    Drawer.prototype.__vzyPatched = true;
    document.querySelectorAll('cart-drawer').forEach((drawer) => {
      drawer.addEventListener('click', (event) => {
        const addOneButton = event.target.closest('.vzy-drawer-aov__button');
        if (addOneButton) addOneButton.setAttribute('name', 'plus');
      });
    });
    Drawer.prototype.updateVzyHeading = function (mode = 'cart') {
      const title = this.querySelector('[data-drawer-title]');
      if (!title) return;
      const added = mode === 'added';
      title.textContent = added ? 'Adăugat în coș' : 'Coșul tău';
      title.closest('.drawer__header')?.classList.toggle('drawer__header--added', added);
    };

    Drawer.prototype.open = function (triggeredBy) {
      const mode = this.dataset.vzyOpenMode || 'cart';
      delete this.dataset.vzyOpenMode;
      this.updateVzyHeading(mode);
      const result = originalOpen.call(this, triggeredBy);

      const enforceDrawerFocus = () => {
        if (!this.classList.contains('active')) return;
        const container = this.querySelector('.drawer__inner');
        const focusTarget = this.querySelector('.drawer__close') || container;
        if (container && focusTarget && typeof trapFocus === 'function') {
          trapFocus(container, focusTarget);
        } else if (focusTarget instanceof HTMLElement) {
          focusTarget.focus({ preventScroll: true });
        }
      };

      this.addEventListener('transitionend', enforceDrawerFocus, { once: true });
      window.setTimeout(enforceDrawerFocus, 450);
      return result;
    };

    Drawer.prototype.renderContents = function (parsedState) {
      const trigger = document.activeElement;
      if (trigger instanceof HTMLElement && !this.contains(trigger)) {
        this.setActiveElement(trigger);
      }
      this.dataset.vzyOpenMode = 'added';
      return originalRenderContents.call(this, parsedState);
    };
  });
})();

